export const encodeQuery = (queryObject) => Object.entries(queryObject)
    .filter(([, v]) => typeof v !== "undefined")
    .map(([k, v]) => encodeURIComponent(k) + (v != null ? "=" + encodeURIComponent(v) : ""))
    .join("&");
